// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3jaIa","selects":"Documents_selects__q3jRL"};